<form class="f-col blank-form" [formGroup]="businessUnitForm">
    <div class="section-heading">
        <h2 class="h2-heading">{{content?.['b2b.managecompany.buotitle']}}
        </h2>
        <a role="button" class="link"
            *ngIf="commonObjPipes.GetAllDetails.pipe.length>0 && !Addnew" (click)="addNewBusinessUnit()"><mat-icon fontSet="material-symbols-outlined"
                class="edit-icon">add</mat-icon> {{content?.['b2b.managecompany.addnew']}}</a>
    </div>

    <div class="section-content" *ngIf="Addnew">
        <div class="inner-contentsection">
            <div class="f-row two--ColLayout">
                <div class="f-col">
                    <mat-form-field>
                        <mat-label>{{content?.['b2b.managecompany.buobusiunitcode']}}</mat-label>
                        <input matInput formControlName="businessUnitCode" (keypress)="_CommonService.blockSpecialChar($event)" (paste)="onPasteBlocked($event)" (contextmenu)="disableRightClick($event)">
                        <mat-error *ngIf="businessUnitForm.get('businessUnitCode')?.hasError('required')"> {{dictionaryContent?.['b2b.managecompany.businessunitcodereq']}} </mat-error>
                        <mat-error *ngIf="businessUnitForm.get('businessUnitCode')?.hasError('maxlength')"> {{dictionaryContent?.['b2b.managecompany.businessunit30char']}} </mat-error> 
                    </mat-form-field>
                </div>

                <div class="f-col">
                    <mat-form-field>
                        <mat-label>{{content?.['b2b.managecompany.buobusiunitname']}}</mat-label>
                        <input matInput formControlName="businessUnitName" (keypress)="_CommonService.blockSpecialChar($event)" (paste)="onPasteBlocked($event)" (contextmenu)="disableRightClick($event)">
                        <mat-error *ngIf="businessUnitForm.get('businessUnitName')?.hasError('required')"> {{dictionaryContent?.['b2b.managecompany.businessunitnamereq']}} </mat-error>
                        <mat-error *ngIf="businessUnitForm.get('businessUnitName')?.hasError('maxlength')"> {{dictionaryContent?.['b2b.managecompany.businessunitnamemaxlimit']}} </mat-error>
                        <mat-error *ngIf="businessUnitForm.get('businessUnitName')?.hasError('minlength')"> {{dictionaryContent?.['b2b.managecompany.businessunitnameminlimit']}} </mat-error>
                    </mat-form-field>
                </div>
            </div>
            <div class="f-row two--ColLayout">
                <div class="f-col">
                    <mat-form-field>
                        <mat-label>{{content?.['b2b.managecompany.buobusiunithead']}}</mat-label>
                        <input matInput formControlName="businessUnitHead" (keypress)="blockInvalidCharacters1($event)" (paste)="onPasteBlocked($event)" (contextmenu)="disableRightClick($event)" data-dd-privacy="mask">
                        <mat-error *ngIf="businessUnitForm.get('businessUnitHead')?.hasError('required')"> {{dictionaryContent?.['b2b.managecompany.businessunitheadreq']}} </mat-error>
                        <mat-error *ngIf="businessUnitForm.get('businessUnitHead')?.hasError('maxlength')"> {{dictionaryContent?.['b2b.managecompany.businessunitheadmaxlimit']}} </mat-error>
                        <mat-error *ngIf="businessUnitForm.get('businessUnitHead')?.hasError('minlength')"> {{dictionaryContent?.['b2b.managecompany.businessunitheadminlimit']}} </mat-error>
                    </mat-form-field>
                </div>
                <div class="f-col">
                    <mat-form-field>
                        <mat-label>{{content?.['b2b.managecompany.buobusiunitemail']}}</mat-label>
                        <input matInput formControlName="businessUnitEmail" (keypress)="blockInvalidCharactersForEmail($event)" (paste)="onPasteBlocked($event)" (contextmenu)="disableRightClick($event)" data-dd-privacy="mask">
                        <mat-error *ngIf="businessUnitForm.get('businessUnitEmail')?.hasError('required')"> {{dictionaryContent?.['b2b.managecompany.businessunitemailreq']}} </mat-error>
                        <mat-error *ngIf="businessUnitForm.get('businessUnitEmail')?.hasError('email') || businessUnitForm.get('businessUnitEmail')?.hasError('pattern')"> {{dictionaryContent?.['b2b.managetraveler.entervalidemail']}} </mat-error>
                        <mat-error *ngIf="businessUnitForm.get('businessUnitEmail')?.hasError('minlength')"> {{dictionaryContent?.['b2b.managecompany.emaillength']}} </mat-error>
                        <mat-error *ngIf="businessUnitForm.get('businessUnitEmail')?.hasError('maxlength')"> Email cannot exceed 200 characters.</mat-error>
                    </mat-form-field>
                </div>
            </div>
            <div class="f-row">
                <div class="f-col">
                    <mat-form-field appearance="fill">
                        <mat-label>{{content?.['b2b.managecompany.buocontactmobile']}}</mat-label>
                        <input matInput formControlName="businessUnitContactNo" (keypress)="allowedNumberOnly($event)" (paste)="onPasteBlocked($event)" (contextmenu)="disableRightClick($event)" data-dd-privacy="mask">
                        <mat-error *ngIf="businessUnitForm.get('businessUnitContactNo')?.hasError('required')"> {{dictionaryContent?.['b2b.register.mobilereq'] || 'Mobile number is required.'}} </mat-error>
                        <mat-error *ngIf="businessUnitForm.get('businessUnitContactNo')?.hasError('minlength')">{{dictionaryContent?.['b2b.managecompany.mobilenumber7digit']}}</mat-error>
                        <mat-error *ngIf="businessUnitForm.get('businessUnitContactNo')?.hasError('maxlength')">{{dictionaryContent?.['b2b.managecompany.mobilenumbermaxlimit']}}</mat-error>
                        <mat-icon fontSet="material-symbols-outlined" matSuffix>phone_android</mat-icon>
                    </mat-form-field>
                </div>
            </div>

            <!-- <div class="f-row two--ColLayout">
                <div class="f-col">
                    <mat-form-field>
                        <mat-label>Select Expiry Month </mat-label>
                        <mat-icon fontSet="material-symbols-outlined" matSuffix class="mat-select">stat_minus_1</mat-icon>
                        <mat-select>
                            <mat-option> NA </mat-option>
                        </mat-select>
                    </mat-form-field>
                </div>

                <div class="f-col">
                    <mat-form-field>
                        <mat-label>Select Expiry Year</mat-label>
                        <mat-icon fontSet="material-symbols-outlined" matSuffix class="mat-select">stat_minus_1</mat-icon>
                        <mat-select>
                            <mat-option> NA </mat-option>
                        </mat-select>
                    </mat-form-field>
                </div>
            </div> -->

            <div class="f-row">
                <div class="f-col">
                    <div class="f-row validation-col">
                        <label class="mat-label">{{content?.['b2b.managecompany.status']}}</label>
                        <mat-radio-group aria-label="Select an option" formControlName="status">
                            <mat-radio-button selected [value]=true>{{content?.['b2b.managecompany.active']}}</mat-radio-button>
                            <mat-radio-button [value]=false>{{content?.['b2b.managecompany.inactive']}}</mat-radio-button>
                        </mat-radio-group>
                    </div>
                </div>
            </div>

            <!-- <div class="f-row">
                <div class="f-col">
                    <div class="f-row validation-col">
                        <label class="mat-label">Associate with Branch:</label>
                        <div class="f-row mat-check-group">
                            <mat-checkbox class="checkbox-wrapper" *ngFor="let branch of commonObjPipes.GetAssociatedWithBranchId.pipe"
                            (change)="onCheckboxChange($event,branch.ID)"
                            [checked]="associateWithBranchArray.includes(branch.ID.toString())">{{branch.Name}}</mat-checkbox>
                        </div>
                    </div>
                </div>
            </div> -->

            <div class="f-row">
                <mat-form-field class="mat-chip-input custom-businessUnit-mat-dropdown-parent">
                    <mat-label>{{content?.['b2b.managecompany.associateoficelocation']}}</mat-label>
                    <mat-chip-grid #chipGrid aria-label="Fruit selection">
                        <mat-chip-row *ngFor="let name of BranchName" (removed)="remove(name)">
                            {{name}}
                            <button matChipRemove [attr.aria-label]="'remove ' + name">
                                <mat-icon fontSet="material-symbols-outlined">close</mat-icon>
                            </button>
                        </mat-chip-row>
                    </mat-chip-grid>
                    <input [placeholder]="content?.['b2b.managecompany.select']" #fruitInput [formControl]="associatedWithBranchId" [matChipInputFor]="chipGrid" [matAutocomplete]="auto" [matChipInputSeparatorKeyCodes]="separatorKeysCodes" (matChipInputTokenEnd)="add($event)" (keypress)="blockInvalidCharacters($event)" (paste)="onPasteBlocked($event)" (contextmenu)="disableRightClick($event)" maxlength="50" data-dd-privacy="mask" />
                    <mat-icon fontSet="material-symbols-outlined" matSuffix class="mat-select">stat_minus_1</mat-icon>
                    <mat-autocomplete #auto="matAutocomplete" class="custom-autocomplete">
                        <mat-option *ngFor="let branch of filteredBranch | async" [value]="branch.corpBranchId">
                            <div (keydown)="optionClicked(branch); $event.stopPropagation()" (keyup)="optionClicked(branch); $event.stopPropagation()" (click)="optionClicked(branch); $event.stopPropagation()">
                                <mat-checkbox class="checkbox-wrapper" [checked]="selectedBranchIdsMap[branch.corpBranchId]" (change)="onCheckboxChange($event, branch, 'custom-businessUnit-mat-dropdown-parent','custom-autocomplete')" (click)="$event.stopPropagation()"></mat-checkbox>
                                {{branch.corpBranchName}}
                            </div>
                        </mat-option>
                    </mat-autocomplete>
                    <mat-error *ngIf="businessUnitForm.get('associatedWithBranchId')?.hasError('required') || associatedWithBranchId?.hasError('required')">{{dictionaryContent?.['b2b.managecompany.associatebranchreq']}}</mat-error>
                </mat-form-field>
            </div>
            <mat-error *ngIf="associatedWithBranchId.touched && noRecordFound">{{content?.['b2b.managecompany.recordnotfound']}} </mat-error>

        </div>
        <div class="inner-action">
            <button mat-button class="button--secondary-small" (click)="onCancel()">{{content?.['b2b.managecompany.cancel']}}</button>
            <button mat-button class="button--primary-small" (click)="onSave()" [class.disabled]="businessUnitForm.invalid">{{content?.['b2b.managecompany.save']}}</button>
        </div>
    </div>
    <div class="section-table data-listing" *ngIf="commonObjPipes.GetAllDetails.pipe.length>0 && !Addnew">
        <table mat-table [dataSource]="commonObjPipes.GetAllDetails.pipe" class="mat-elevation-z0">
            <!-- Position Column -->
            <ng-container matColumnDef="Business Unit Name">
                <th mat-header-cell *matHeaderCellDef>{{content?.['b2b.managecompany.buobusiunitname']}}</th>
                <td mat-cell *matCellDef="let element"> {{element.businessUnitName}} </td>
            </ng-container>

            <!-- Name Column -->
            <ng-container matColumnDef="Business Unit Code">
                <th mat-header-cell *matHeaderCellDef> {{content?.['b2b.managecompany.buobusiunitcode']}} </th>
                <td mat-cell *matCellDef="let element"> {{element.businessUnitCode}} </td>
            </ng-container>

            <ng-container matColumnDef="Status">
                <th mat-header-cell *matHeaderCellDef> {{content?.['b2b.managecompany.ddstatus']}} </th>
                <td mat-cell *matCellDef="let element" class="status-tag">
                    <span
                        [ngClass]="element.status ? 'status-active' : 'status-inactive'">
                        {{ element.status ? (content?.['b2b.managecompany.active']) : (content?.['b2b.managecompany.inactive']) }}
                    </span>
                </td>
            </ng-container>

            <!-- Symbol Column -->
            <ng-container matColumnDef="Actions">
                <th mat-header-cell *matHeaderCellDef> {{content?.['b2b.managecompany.ddactions']}} </th>
                <td mat-cell *matCellDef="let element" class="onclick-links">
                    <!-- <a class="onclick-cell primary-link" (click)="onEdit(element)">{{content?.['b2b.managecompany.cdedit']}}</a>
                    <a class="onclick-cell warm-link" (click)="onRemove(element)">{{content?.['b2b.managecompany.cdremove']}}</a> -->
                    <button type="button" class="onclick-cell primary-link button-as-span" aria-label="Edit button" (click)="onEdit(element)"><mat-icon fontSet="material-symbols-outlined">Edit</mat-icon></button>
                    <button type="button" class="onclick-cell warm-link button-as-span" aria-label="Remove button" (click)="onRemove(element)"><mat-icon fontSet="material-symbols-outlined">Delete</mat-icon></button>
                </td>
            </ng-container>

            <tr mat-header-row *matHeaderRowDef="displayedColumns"></tr>
            <tr mat-row *matRowDef="let row; columns: displayedColumns;"></tr>
        </table>
    </div>

    <ng-container *ngIf="!isLoading && commonObjPipes.GetAllDetails.pipe.length==0 && !Addnew">
        <app-cam-empty-state (myEvent)="handleEvent($event)" [heading]="content?.['b2b.managecompany.buonobusiunittitle']"
            [content]="content?.['b2b.managecompany.buonobusiunitdesc']"
            [navigateTo]="'/cam/company-management/business-unit-overview'">
        </app-cam-empty-state>
    </ng-container>
</form>

<ng-template #selectionWarning>
    <div class="custom-dialog">
        <div class="d-justify-bw">
            <div class="custom-dialog__left">
                <div class="mat-dialog-title custom-dialog__title d-justify-bw">
                    <h2 class="mat-dialog-title"> {{content?.warningList[0]?.title}}</h2>
                    <!-- <div class="custom-overlay-close">
                        <mat-icon fontSet="material-symbols-outlined" class="close_icon" (click)="CloseDialog(false)">close</mat-icon>
                    </div> -->
                </div>
                <mat-dialog-content class="custom-dialog__text">
                    <div class="custom-dialog__description">Are you sure you want to remove this Business unit?</div>
                </mat-dialog-content>
                <mat-dialog-actions>
                    <div class="dialog-actions-right">
                        <button class="button--secondary-small" mat-button (click)="CloseDialog(false)">{{content?.warningList[0]?.cancelCTAText}}</button>
                        <button class="button--primary-small" mat-button (click)="CloseDialog(true)">{{content?.warningList[0]?.confirmCTAText}}</button>
                    </div>
                </mat-dialog-actions>
            </div>
        </div>
    </div>
</ng-template>